export default "__VITE_ASSET__Dq8xSV19__"